import { render, staticRenderFns } from "./Internships.vue?vue&type=template&id=2eb959e7&scoped=true"
import script from "./Internships.vue?vue&type=script&lang=js"
export * from "./Internships.vue?vue&type=script&lang=js"
import style0 from "./Internships.vue?vue&type=style&index=0&id=2eb959e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb959e7",
  null
  
)

export default component.exports